export enum NotificationKind {
  Informative = 'informative',
  Positive = 'positive',
  Warning = 'warning',
  Negative = 'negative',
  Secondary = 'secondary',
}

interface Notification {
  id?: string
  kind: NotificationKind
  title?: string
  description?: string
  closeAfter?: number
}

export const notifications = ref<Notification[]>([])

export const bottomShift = ref(0)

let id = 0
export function useUid() {
  return String(id++)
}

function addNotification(notification: Notification) {
  notification.id ||= useUid()
  notifications.value.push(notification)
  if (notification.closeAfter && notification.closeAfter > 0) {
    setTimeout(() => deleteNotification(notification.id as string), notification.closeAfter)
  }
}

export function deleteNotification(id: string) {
  const index = notifications.value.findIndex(el => el.id === id)
  if (index > -1) {
    notifications.value.splice(index, 1)
  }
}

export function addSuccess(title: string, description?: string, { closeAfter = 3000 } = {}) {
  addNotification({
    kind: NotificationKind.Positive,
    title,
    description,
    closeAfter,
  })
}

export function addError(title: string, description?: unknown, { closeAfter = 5000 } = {}) {
  const cause = description instanceof Error ? description.cause : undefined

  addNotification({
    kind: NotificationKind.Negative,
    title,
    description: typeof cause === 'string' ? cause : typeof description === 'string' ? description : undefined,
    closeAfter,
  })
}

export function addWarning(title: string, description?: string, { closeAfter = 5000 } = {}) {
  addNotification({
    kind: NotificationKind.Warning,
    title,
    description,
    closeAfter,
  })
}
